import {
  inject,
  Injectable,
} from '@angular/core';
import {Observable} from 'rxjs';
import {ApolloLink} from '@apollo/client';
import {GET_NOGA_INDUSTRIES} from '../queries/noga-industries.query.model';
import {ApiGraphqlService} from '../../core/api-graphql/api-graphql.service';
import {AnyObject} from '../../../../../models/object.model';

@Injectable({
  providedIn: 'root',
})
export class ApiNogaIndustriesService {

  private apiGraphqlService = inject(ApiGraphqlService);

  /**
   * Method API: Get noga industries (used query)
   * @return: Observable
   */
  getNogaIndustriesObservable(): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.query(GET_NOGA_INDUSTRIES);
  }

}
